import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/home',
            name: 'home',
            component: () =>
                import ('@/views/home.vue')
        }, {
            path: '/',
            name: 'login',
            component: () =>
                import ('@/views/login.vue')
        }, {
            path: '/list',
            name: 'list',
            component: () =>
                import ('@/views/list.vue')
        },
        {
            path: '/judges',
            name: 'judges',
            component: () =>
                import ('@/views/judges.vue')
        },
        {
            path: '/player',
            name: 'player',
            component: () =>
                import ('@/views/player.vue')
        }, {
            path: '/bigScreen',
            name: 'bigScreen',
            component: () =>
                import ('@/views/bigScreen.vue')
        }, {
            path: '/siteManagement',
            name: 'siteManagement',
            component: () =>
                import ('@/views/siteManagement.vue')
        }, {
            path: '/result',
            name: 'result',
            component: () =>
                import ('@/views/result.vue')
        }, {
            path: '/largeScreenDisply',
            name: 'largeScreenDisply',
            component: () =>
                import ('@/views/largeScreenDisply.vue')
        },
        {
          path: '/questionBank',
          name: 'questionBank',
          component: () =>
            import ('@/views/questionBank.vue')
        },
      {
        path: '/questionManage',
        name: 'questionManage',
        component: () =>
          import ('@/views/questionManage.vue')
      },
		{
		    path: '/scoresetup',
		    name: 'scoresetup',
		    component: () =>
		        import ('@/views/scoresetup.vue')
		}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js